var _defs, _path, _path2, _path3, _polyline;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCloseRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.5994,
    height: 44.6948,
    viewBox: "0 0 45.5994 44.6948",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b8252f;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.7964,44.6401c-.8262,0-1.6523-.3135-2.2815-.9424l-.0002-.001c-1.2573-1.2578-1.2573-3.3047,0-4.5625L28.8306,11.8178c1.2185-1.2188,3.344-1.2197,4.5635.001.6091.6084.9448,1.4189.9448,2.2813,0,.8613-.3354,1.6719-.9448,2.2813L6.0781,43.6977c-.6292.6279-1.4553.9424-2.2817.9424ZM2.7522,42.4594c.5767.5771,1.5134.5762,2.0886,0l27.3157-27.3154c.2788-.2783.4324-.6494.4324-1.0439s-.1533-.7656-.4324-1.0439c-.5579-.5586-1.5305-.5566-2.0884-.001L2.7522,40.3716c-.5754.5752-.5754,1.5127,0,2.0879Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.3728,44.6948H3.7424c-1.7793,0-3.2268-1.4473-3.2268-3.2266s1.4475-3.2266,3.2268-3.2266h38.6304c1.7791,0,3.2266,1.4473,3.2266,3.2266s-1.4475,3.2266-3.2266,3.2266ZM3.7424,39.9917c-.8142,0-1.4768.6621-1.4768,1.4766s.6626,1.4766,1.4768,1.4766h38.6304c.8142,0,1.4766-.6621,1.4766-1.4766s-.6624-1.4766-1.4766-1.4766H3.7424Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.9976,22.3051l-1.9976-.0957c.1399-2.9229.9602-5.6904,2.4375-8.2256C6.2725,7.4047,13.689,3.9575,21.3318,5.2016l-.3213,1.9746c-6.8191-1.1152-13.4307,1.9561-16.845,7.8154-1.314,2.2539-2.0435,4.7148-2.168,7.3135Z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "18.3232 0 28.6378 5.8909 18.3939 12.0779"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseRed);
export default __webpack_public_path__ + "static/media/icon_close_red.da3ebfacfb24139484fd400fa3a8ea22.svg";
export { ForwardRef as ReactComponent };